import {
  TIME_SLOT_SELECTION_ERROR,
  COMPLETE_DOCUMENT_UPLOAD_ERROR
} from './submissionErrorConstants';

export const isBlockingError = (errorMessage: string): boolean => {
  return (
    errorMessage === TIME_SLOT_SELECTION_ERROR || errorMessage === COMPLETE_DOCUMENT_UPLOAD_ERROR
  );
};
